import { render, staticRenderFns } from "./ExpressCheckoutButton.vue?vue&type=template&id=ad36dd4c&scoped=true"
import script from "./ExpressCheckoutButton.vue?vue&type=script&lang=js"
export * from "./ExpressCheckoutButton.vue?vue&type=script&lang=js"
import style0 from "./ExpressCheckoutButton.vue?vue&type=style&index=0&id=ad36dd4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.94.0__lodash@4.17.21__ar4y5aobbfwjol7cdxadoh6aqe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad36dd4c",
  null
  
)

export default component.exports